import { Navigate } from 'react-router-dom';
import { hasRole, useAuth } from '../auth/AuthProvider';
import Landing from './Landing';
import { Button } from '../ui/button';
import { Heading } from '../ui/heading';
import { Text } from '../ui/text';

export default function Index() {
  const { ready, user, groups, email } = useAuth();

  if (!ready) return null;

  if (!user) {
    return <Landing />;
  }

  if (hasRole(groups, 'admin', 'team-admin', 'scorekeeper')) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <div className="mx-auto max-w-2xl space-y-6 py-10">
      <div>
        <Heading>Welcome{email ? `, ${email}` : ''}.</Heading>
        <Text className="mt-2">
          You haven&rsquo;t followed any teams yet. Browse available teams to find one
          to follow.
        </Text>
      </div>
      <Button href="/teams" color="dark/zinc">
        Browse teams
      </Button>
    </div>
  );
}
